import Head from 'next/head';
import SiteLayout from '@/components/layout/SiteLayout';
import { ProjectSection } from '@/components/sections/ProjectSection';
import { alleProjekte } from '@/lib/content/projekte';
import { vorschaubilder } from '@/lib/images';

const seo = {
  title: 'Marlene Gujan Architektur AG | Projekte',
  description: 'Erkunden Sie die vielfältigen und innovativen Projekte von Marlene Gujan Architektur AG in Igis, die für herausragende Architektur stehen.',
  keywords: 'Projekte, Architektur, Igis, Marlene Gujan, Bauprojekte, innovative Architektur',
  canonicalUrl: 'https://www.gujan-architektur.ch/projekte',
};

export default function Projekte({ data, imageUrls }) {
  return (
    <SiteLayout>
      <Head>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <link rel="canonical" href={seo.canonicalUrl} />
      </Head>
      <ProjectSection data={data} imageUrls={imageUrls} />
    </SiteLayout>
  );
}

export async function getStaticProps() {
  const data = await alleProjekte();
  // Frueher ein Request pro Projekt gegen /api/getImages - bei rund 30
  // Projekten also 31 Aufrufe, bevor die Seite etwas zeigte.
  const imageUrls = vorschaubilder(data.map((p) => p.projekt_id));
  return { props: { data, imageUrls }, revalidate: 300 };
}
